import {gql} from '@apollo/client'

export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign(
    $name: String!
    $description: String
    $enabledChannels: [String!]!
    $scheduleType: String
    $scheduledTime: DateTime
    $recurringRule: String
    $targetSegment: GenericScalar
    $templateId: ID
    $metadata: GenericScalar
    $strategy: String
  ) {
    createCampaign(
      name: $name
      description: $description
      enabledChannels: $enabledChannels
      scheduleType: $scheduleType
      scheduledTime: $scheduledTime
      recurringRule: $recurringRule
      targetSegment: $targetSegment
      templateId: $templateId
      metadata: $metadata
      strategy: $strategy
    ) {
      ok
      errors
      campaign {
        id
        name
        status
        strategy
        scheduleType
        enabledChannels
        totalTargets
      }
    }
  }
`

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign(
    $id: ID!
    $name: String
    $description: String
    $enabledChannels: [String!]
    $scheduleType: String
    $scheduledTime: DateTime
    $recurringRule: String
    $targetSegment: GenericScalar
    $templateId: ID
    $metadata: GenericScalar
    $strategy: String
    $status: String
    $isArchived: Boolean
  ) {
    updateCampaign(
      id: $id
      name: $name
      description: $description
      enabledChannels: $enabledChannels
      scheduleType: $scheduleType
      scheduledTime: $scheduledTime
      recurringRule: $recurringRule
      targetSegment: $targetSegment
      templateId: $templateId
      metadata: $metadata
      strategy: $strategy
      status: $status
      isArchived: $isArchived
    ) {
      ok
      errors
      campaign {
        id
        name
        status
        strategy
        scheduleType
        enabledChannels
        scheduledTime
        metadata
      }
    }
  }
`

export const ADD_CAMPAIGN_TARGETS = gql`
  mutation AddCampaignTargets($campaignId: ID!, $targets: [CampaignTargetInput!]!) {
    addCampaignTargets(campaignId: $campaignId, targets: $targets) {
      ok
      campaign {
        id
        totalTargets
      }
      targets {
        id
        state
        contact {
          id
          firstName
          lastName
          email
          phone
        }
      }
    }
  }
`

export const LAUNCH_CAMPAIGN = gql`
  mutation LaunchCampaign($id: ID!, $runAsync: Boolean) {
    launchCampaign(id: $id, runAsync: $runAsync) {
      ok
      taskId
      campaign {
        id
        status
        lastRunTaskId
      }
      result
    }
  }
`

export const PAUSE_CAMPAIGN = gql`
  mutation PauseCampaign($id: ID!) {
    pauseCampaign(id: $id) {
      ok
      campaign {
        id
        status
      }
    }
  }
`

export const SEND_CAMPAIGN_TEST_MESSAGE = gql`
  mutation SendCampaignTestMessage(
    $templateId: ID!
    $recipient: String!
    $channels: [String!]!
    $fromEmail: String
    $fromName: String
    $replyTo: String
    $includeLogo: Boolean
  ) {
    sendCampaignTestMessage(
      templateId: $templateId
      recipient: $recipient
      channels: $channels
      fromEmail: $fromEmail
      fromName: $fromName
      replyTo: $replyTo
      includeLogo: $includeLogo
    ) {
      ok
      results
    }
  }
`

export const CREATE_MESSAGE_TEMPLATE = gql`
  mutation CreateMessageTemplate(
    $name: String!
    $channel: String
    $subject: String
    $body: String
    $description: String
    $variables: [String!]
    $metadata: GenericScalar
    $enabledChannels: [String]
  ) {
    createMessageTemplate(
      name: $name
      channel: $channel
      subject: $subject
      body: $body
      description: $description
      variables: $variables
      metadata: $metadata
      enabledChannels: $enabledChannels
    ) {
      ok
      template {
        id
        name
        channel
        subject
        body
        metadata
      }
      errors
    }
  }
`

export const UPDATE_MESSAGE_TEMPLATE = gql`
  mutation UpdateMessageTemplate(
    $id: ID!
    $name: String
    $subject: String
    $body: String
    $description: String
    $variables: [String!]
    $metadata: GenericScalar
    $isActive: Boolean
    $enabledChannels: [String]
  ) {
    updateMessageTemplate(
      id: $id
      name: $name
      subject: $subject
      body: $body
      description: $description
      variables: $variables
      metadata: $metadata
      isActive: $isActive
      enabledChannels: $enabledChannels
    ) {
      ok
      template {
        id
        name
        channel
        subject
        body
        metadata
      }
      errors
    }
  }
`

export const CREATE_CHANNEL_VARIANT = gql`
  mutation CreateChannelVariant($templateId: ID!, $variantInput: ChannelVariantInput!) {
    createChannelVariant(templateId: $templateId, variantInput: $variantInput) {
      ok
      variant {
        id
        channel
        subject
        bodyText
        bodyHtml
        whatsappTemplateId
        whatsappLanguage
        whatsappTemplateParams
        smsMaxLength
        isDefault
        variables
        metadata
      }
      errors
    }
  }
`

export const UPDATE_CHANNEL_VARIANT = gql`
  mutation UpdateChannelVariant(
    $id: ID!
    $subject: String
    $bodyText: String
    $bodyHtml: String
    $whatsappTemplateId: String
    $whatsappLanguage: String
    $whatsappTemplateParams: [String!]
    $smsMaxLength: Int
    $isDefault: Boolean
    $variables: [String!]
    $metadata: GenericScalar
  ) {
    updateChannelVariant(
      id: $id
      subject: $subject
      bodyText: $bodyText
      bodyHtml: $bodyHtml
      whatsappTemplateId: $whatsappTemplateId
      whatsappLanguage: $whatsappLanguage
      whatsappTemplateParams: $whatsappTemplateParams
      smsMaxLength: $smsMaxLength
      isDefault: $isDefault
      variables: $variables
      metadata: $metadata
    ) {
      ok
      variant {
        id
        channel
        subject
        bodyText
        bodyHtml
        whatsappTemplateId
        whatsappLanguage
        whatsappTemplateParams
        smsMaxLength
        isDefault
        variables
        metadata
      }
      errors
    }
  }
`

export const DELETE_CHANNEL_VARIANT = gql`
  mutation DeleteChannelVariant($id: ID!) {
    deleteChannelVariant(id: $id) {
      ok
    }
  }
`

export const ADD_CAMPAIGN_TARGETS_BY_FILTER = gql`
  mutation AddCampaignTargetsByFilter(
    $campaignId: ID!
    $name: String
    $state: String
    $carrier: String
    $policyStatus: String
    $effectiveYear: String
    $tags: String
    $user: String
    $isPolicyHolder: Boolean
    $withoutPolicy: Boolean
  ) {
    addCampaignTargetsByFilter(
      campaignId: $campaignId
      name: $name
      state: $state
      carrier: $carrier
      policyStatus: $policyStatus
      effectiveYear: $effectiveYear
      tags: $tags
      user: $user
      isPolicyHolder: $isPolicyHolder
      withoutPolicy: $withoutPolicy
    ) {
      ok
      addedCount
      skippedCount
      campaign {
        id
        totalTargets
      }
    }
  }
`

export const REMOVE_CAMPAIGN_TARGETS_BY_FILTER = gql`
  mutation RemoveCampaignTargetsByFilter(
    $campaignId: ID!
    $name: String
    $state: String
    $carrier: String
    $policyStatus: String
    $effectiveYear: String
    $tags: String
    $user: String
    $isPolicyHolder: Boolean
    $withoutPolicy: Boolean
  ) {
    removeCampaignTargetsByFilter(
      campaignId: $campaignId
      name: $name
      state: $state
      carrier: $carrier
      policyStatus: $policyStatus
      effectiveYear: $effectiveYear
      tags: $tags
      user: $user
      isPolicyHolder: $isPolicyHolder
      withoutPolicy: $withoutPolicy
    ) {
      ok
      removedCount
      campaign {
        id
        totalTargets
      }
    }
  }
`

export const SYNC_CAMPAIGN_TARGETS = gql`
  mutation SyncCampaignTargets($campaignId: ID!, $contactIds: [ID!]!) {
    syncCampaignTargets(campaignId: $campaignId, contactIds: $contactIds) {
      ok
      addedCount
      removedCount
      campaign {
        id
        totalTargets
      }
    }
  }
`

export const CLEAR_CAMPAIGN_TARGETS = gql`
  mutation ClearCampaignTargets($campaignId: ID!) {
    clearCampaignTargets(campaignId: $campaignId) {
      ok
      deletedCount
      campaign {
        id
        totalTargets
      }
    }
  }
`

export const DELETE_CAMPAIGN_TARGET = gql`
  mutation DeleteCampaignTarget($id: ID!) {
    deleteCampaignTarget(id: $id) {
      ok
      campaign {
        id
        totalTargets
      }
    }
  }
`

export const DUPLICATE_MESSAGE_TEMPLATE = gql`
  mutation DuplicateMessageTemplate($id: ID!, $newName: String!) {
    duplicateMessageTemplate(id: $id, newName: $newName) {
      ok
      template {
        id
        name
        channel
        allChannels
        subject
        body
        description
        variables
        metadata
        isActive
        variants {
          id
          channel
          subject
          bodyText
          bodyHtml
          isDefault
        }
      }
      errors
    }
  }
`

export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($id: ID!) {
    deleteCampaign(id: $id) {
      ok
      errors
    }
  }
`

export const TOGGLE_TEMPLATE_BLUEPRINT = gql`
  mutation ToggleTemplateBlueprint($id: ID!, $isBlueprint: Boolean!) {
    toggleTemplateBlueprint(id: $id, isBlueprint: $isBlueprint) {
      ok
      template {
        id
        isBlueprint
      }
    }
  }
`

// ─── Automation Template Mutations ───────────────────────────────────────────

export const CREATE_AUTOMATION_TEMPLATE = gql`
  mutation CreateAutomationTemplate(
    $name: String!
    $description: String
    $category: String
    $triggerType: String!
    $triggerConfig: GenericScalar
    $channel: String!
    $delayDays: Int
    $sendHour: Int
    $sendMinute: Int
    $suggestedTemplateId: ID
  ) {
    createAutomationTemplate(
      name: $name
      description: $description
      category: $category
      triggerType: $triggerType
      triggerConfig: $triggerConfig
      channel: $channel
      delayDays: $delayDays
      sendHour: $sendHour
      sendMinute: $sendMinute
      suggestedTemplateId: $suggestedTemplateId
    ) {
      ok
      errors
      automationTemplate {
        id
        name
        description
        category
        triggerType
        triggerConfig
        channel
        delayDays
        sendHour
        sendMinute
        createdAt
      }
    }
  }
`

export const UPDATE_AUTOMATION_TEMPLATE = gql`
  mutation UpdateAutomationTemplate(
    $id: ID!
    $name: String
    $description: String
    $category: String
    $triggerType: String
    $triggerConfig: GenericScalar
    $channel: String
    $delayDays: Int
    $sendHour: Int
    $sendMinute: Int
    $suggestedTemplateId: ID
  ) {
    updateAutomationTemplate(
      id: $id
      name: $name
      description: $description
      category: $category
      triggerType: $triggerType
      triggerConfig: $triggerConfig
      channel: $channel
      delayDays: $delayDays
      sendHour: $sendHour
      sendMinute: $sendMinute
      suggestedTemplateId: $suggestedTemplateId
    ) {
      ok
      errors
      automationTemplate {
        id
        name
        description
        category
        triggerType
        triggerConfig
        channel
        delayDays
        sendHour
        sendMinute
      }
    }
  }
`

export const DELETE_AUTOMATION_TEMPLATE = gql`
  mutation DeleteAutomationTemplate($id: ID!) {
    deleteAutomationTemplate(id: $id) {
      ok
      errors
    }
  }
`

// ─── Automation Mutations ─────────────────────────────────────────────────────

export const CREATE_AUTOMATION = gql`
  mutation CreateAutomation(
    $name: String!
    $description: String
    $triggerType: String!
    $triggerConfig: GenericScalar
    $channel: String!
    $templateId: ID
    $delayDays: Int
    $sendHour: Int
    $sendMinute: Int
    $conditions: GenericScalar
    $isActive: Boolean
  ) {
    createAutomation(
      name: $name
      description: $description
      triggerType: $triggerType
      triggerConfig: $triggerConfig
      channel: $channel
      templateId: $templateId
      delayDays: $delayDays
      sendHour: $sendHour
      sendMinute: $sendMinute
      conditions: $conditions
      isActive: $isActive
    ) {
      ok
      errors
      automation {
        id
        name
        triggerType
        channel
        isActive
        createdAt
      }
    }
  }
`

export const UPDATE_AUTOMATION = gql`
  mutation UpdateAutomation(
    $id: ID!
    $name: String
    $description: String
    $triggerType: String
    $triggerConfig: GenericScalar
    $channel: String
    $templateId: ID
    $delayDays: Int
    $sendHour: Int
    $sendMinute: Int
    $conditions: GenericScalar
    $isActive: Boolean
  ) {
    updateAutomation(
      id: $id
      name: $name
      description: $description
      triggerType: $triggerType
      triggerConfig: $triggerConfig
      channel: $channel
      templateId: $templateId
      delayDays: $delayDays
      sendHour: $sendHour
      sendMinute: $sendMinute
      conditions: $conditions
      isActive: $isActive
    ) {
      ok
      errors
      automation {
        id
        name
        triggerType
        channel
        isActive
        updatedAt
      }
    }
  }
`

export const TOGGLE_AUTOMATION = gql`
  mutation ToggleAutomation($id: ID!) {
    toggleAutomation(id: $id) {
      ok
      automation {
        id
        isActive
      }
    }
  }
`

export const DELETE_AUTOMATION = gql`
  mutation DeleteAutomation($id: ID!) {
    deleteAutomation(id: $id) {
      ok
      errors
    }
  }
`

export const TRIGGER_AUTOMATION_MANUAL = gql`
  mutation TriggerAutomationManual($automationId: ID!, $contactId: ID!) {
    triggerAutomationManual(automationId: $automationId, contactId: $contactId) {
      ok
      errors
      log {
        id
        status
        channel
        sentAt
      }
    }
  }
`

export const IMPORT_CAMPAIGN_CONTACTS = gql`
  mutation ImportCampaignContacts($contacts: [RecipientInput]!) {
    importCampaignContacts(contacts: $contacts) {
      ok
      addedCount
      taggedExistingCount
      importedIds
    }
  }
`
